import { render, staticRenderFns } from "./IconItineraryLight.vue?vue&type=template&id=08ac1070&"
import script from "./IconItineraryLight.vue?vue&type=script&lang=js&"
export * from "./IconItineraryLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports